<template>
  <layout-base id="gtr-emails-html">
    <div style="display:grid; grid-template-columns: 1fr auto;">
      <!-- INTRO -->
      <external-header :logo="email.logo" />
      <!-- CLIENT LOGO -->
      <external-header width="50" :logo="email.clientLogo" />
    </div>
    <!-- TITLE -->
    <layout-block margin="24px 0">
      <layout-title :title="email.title" color="#000000" />
    </layout-block>
    <!-- BODY -->
    <layout-block margin="24px 0" text-align="left">
      <div style="font-weight: 600;">
        {{ email.data.title }}
      </div>
      <div style="margin-top: 16px;" v-html="email.data.body"></div>
    </layout-block>
    <!-- REVIEW -->
    <layout-block margin="24px 0" v-if="email.data.review || email.data.response">
      <external-review :review="email.data.review" v-if="email.data.review" />
      <external-review
        :review="email.data.response"
        v-if="email.data.response"
        border-color="#2C2E42"
        bg-color="#ffffff"
        :answer="true"
        style="margin-top: -16px;"
      />
    </layout-block>
    <!-- ADDITIONAL INFO -->
    <layout-block margin="24px 0" text-align="left" v-if="email.data.footer" v-html="email.data.footer"></layout-block>
    <layout-block-separator />
    <!-- FOOTER -->
    <layout-block margin="16px 0 0">
      <ui-legend
        :label="email.data.unsubscribe.body"
        font-size="10px"
        margin="0"
        color="#06152F"
        v-if="email.data.unsubscribe"
      />
      <ui-link
        :label="email.data.unsubscribe.link_label"
        :href="email.data.unsubscribe.link_url"
        v-if="email.data.unsubscribe"
      />
    </layout-block>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'
import LayoutTitle from '@/components/Layout/Title.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiLink from '@/components/UI/Link.vue'
import ExternalHeader from '@/components/External/Header.vue'
import ExternalReview from '@/components/External/Review.vue'

export default {
  name: 'userExpress',
  components: {
    LayoutBase,
    LayoutBlock,
    LayoutBlockSeparator,
    LayoutTitle,
    UiLegend,
    UiLink,
    ExternalHeader,
    ExternalReview,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
